import request from '@/utils/request'

// 获取积分概览数据
export function getScoreOverview(params) {
  return request({
    url: '/analysis/overview',
    method: 'get',
    params
  })
}

// 获取积分趋势数据
export function getScoreTrend(params) {
  return request({
    url: '/analysis/trend',
    method: 'get',
    params
  })
}

// 获取积分类别分布数据
export function getScoreCategoryDistribution(params) {
  return request({
    url: '/analysis/category-distribution',
    method: 'get',
    params
  })
}

// 获取部门积分对比数据
export function getDepartmentScoreComparison(params) {
  return request({
    url: '/analysis/department-comparison',
    method: 'get',
    params
  })
}

// 获取员工积分热力图数据
export function getEmployeeScoreHeatmap(params) {
  return request({
    url: '/analysis/employee-heatmap',
    method: 'get',
    params
  })
}

// 获取员工积分详情列表
export function getEmployeeScoreDetails(params) {
  return request({
    url: '/analysis/employee-details',
    method: 'get',
    params
  })
}

// 导出积分分析报表
export function exportScoreReport(params) {
  return request({
    url: '/analysis/export-report',
    method: 'get',
    params,
    responseType: 'blob'
  })
} 